import React, {Component} from "react";
import {observer} from "mobx-react";
import NoData from "../noData";
import {Tooltip} from "antd";
import "./index.less";
import {IPRsp} from "../../bean/ResponseBean";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {getRoutePath, MythRouteId} from "../../router-config";
import {PageLoader} from "../pageLoader";

interface IProps extends RouteComponentProps {
    list: IPRsp[],
    title?: string,
    hideNoData?: boolean,
    className?: string,
    loading: boolean
}

interface IStates {
}

@observer
class ActiveIPList extends Component<IProps, IStates> {
    onClickIPItem = (item: IPRsp) => {
        const url = getRoutePath(MythRouteId.OnePage) + "?ipId=" + item.id;
        this.props.history.push(url);
    };

    parseTime = (licensedTime:string)=>{
        if(licensedTime){
            const index = licensedTime.trim().indexOf(" ");
            if(index > -1){
                return licensedTime.substring(0,index);
            }
        }

        return "";
    };

    render() {
        const {list, hideNoData, className, loading} = this.props;
        return <div className={className}>
            {loading ? <PageLoader marginTop={50}></PageLoader> :
                list && list.length > 0 ? <div className="active-list flex-row">
                    {list.map((item, i) => (
                        <div className="list-item" key={i} onClick={event => {
                            this.onClickIPItem(item)
                        }}>
                            <div className="img-container">
                                <img className="item-img" src={item.image} alt=""/>
                            </div>
                            <div className="text-center item-name">
                                <Tooltip title={item.collectionName + " #" + item.tokenId} color="rgba(255,255,255,0.8)"
                                         overlayClassName="tool-content">
                                    {item.collectionName} #{item.tokenId}
                                </Tooltip>
                            </div>
                            <div className="text-center active-time">license date {this.parseTime(item.licensedTime)}</div>
                        </div>
                    ))}
                </div> : !!hideNoData ? <></> : <NoData/>}
        </div>
    }
}

export default withRouter(ActiveIPList);
